import {
  Component,
  inject,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  afterNextRender,
  signal,
} from '@angular/core';
import { UserProfileComponent } from '@layouts/components/sidenav/components/user-profile/user-profile.component';
import { AppMenuComponent } from '@layouts/components/sidenav/components/app-menu/app-menu.component';
import { SimplebarAngularModule } from 'simplebar-angular';
import { LayoutStoreService } from '@core/services/layout-store.service';
import packageJson from '../../../../../package.json';

@Component({
  selector: 'app-sidenav',
  imports: [UserProfileComponent, AppMenuComponent, SimplebarAngularModule],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidenavComponent {
  public layout = inject(LayoutStoreService);
  readonly appVersion = packageJson.version;

  @ViewChild('menuWrapper', { read: ElementRef })
  menuWrapper!: ElementRef<HTMLElement>;

  isScrolled = signal(false);

  constructor() {
    afterNextRender(() => {
      this.setupScrollListener();
    });
  }

  toggleCollapseMenu(): void {
    this.layout.setSidenavSize(this.layout.sidenavSize === 'default' ? 'collapse' : 'default');
  }

  private setupScrollListener(): void {
    const scrollContainer = document.querySelector(
      '#sidenav .simplebar-content-wrapper',
    ) as HTMLElement;

    if (scrollContainer != null) {
      scrollContainer.addEventListener('scroll', () => {
        this.isScrolled.set(scrollContainer.scrollTop > 5);
      });
    }
  }
}
